import axios from "axios";
import BaseService from "./baseService";

export class ServiceTranslationController extends BaseService {
  async downloadTranslationFiles(): Promise<string> {
    const response = await axios.post('/api/organizations/superadmin/translation/downloadFiles');
    return response.data.processId;
  }

  async getLatestVersionNumber(): Promise<number> {
    const response = await axios.get('/api/organizations/superadmin/translation/latestVersionNumber');
    return response.data.versionNumber;
  }
}

export const ServiceTranslation = new ServiceTranslationController(); 